import styles from "./index.module.css";
import { StepWrapper } from "./CommonStepComponents";
import EditQuizSummary, { EditQuizSummaryProps } from "../confirmation/EditQuizSummary";
import ExemptionSection, { ExemptionSectionProps, ExemptionSectionView } from "../accommodation/ExemptionSection";

type ConfirmationPageProps = {
	loading?: boolean;
	accommodationView?: ExemptionSectionView;
	onViewChange: (view?: ExemptionSectionView) => void;
	numAccommodated: number;
	/** Surfaces with no roster behind them (the Lumina configurator) drop the block entirely. */
	hideAccommodations?: boolean;
} & Pick<
	EditQuizSummaryProps,
	| "pendingLiveSessions"
	| "handleGoToStep"
	| "activeProfile"
	| "allowedCategories"
	| "thirdPartyPlatforms"
	| "applications"
	| "extensions"
	| "proctoringOption"
	| "proctoringAssessmentConfiguration"
	| "quizName"
	| "referenceMaterialFiles"
> &
	Pick<
		ExemptionSectionProps,
		| "exemptionInfo"
		| "onRegisterSave"
		| "canDeleteProfile"
		| "onDelete"
		| "profilesMap"
		| "verityInstituteSettings"
		| "optionRelatedInstituteSettings"
		| "enforcedProfilesOnly"
		| "onInvalidDraft"
		| "onRosterChange"
		| "lms"
	>;

export default function ConfirmationPage({
	pendingLiveSessions,
	loading,
	handleGoToStep,
	enforcedProfilesOnly,
	proctoringOption,
	verityInstituteSettings,
	optionRelatedInstituteSettings,
	proctoringAssessmentConfiguration,
	activeProfile,
	applications,
	extensions,
	thirdPartyPlatforms,
	quizName,
	referenceMaterialFiles,
	accommodationView,
	onViewChange,
	canDeleteProfile,
	onDelete,
	profilesMap,
	allowedCategories,
	exemptionInfo,
	onRegisterSave,
	onRosterChange,
	onInvalidDraft,
	numAccommodated,
	hideAccommodations,
	lms,
}: ConfirmationPageProps) {
	return (
		<StepWrapper>
			<div className={styles.confirmationPage}>
				{accommodationView ? (
					<ExemptionSection
						exemptionInfo={exemptionInfo}
						verityInstituteSettings={verityInstituteSettings}
						enforcedProfilesOnly={enforcedProfilesOnly}
						optionRelatedInstituteSettings={optionRelatedInstituteSettings}
						proctoringData={{ applications, extensions }}
						onBack={() => onViewChange(undefined)}
						canDeleteProfile={canDeleteProfile}
						onDelete={onDelete}
						profilesMap={profilesMap}
						loading={loading}
						onRegisterSave={onRegisterSave}
						onViewChange={onViewChange}
						onRosterChange={onRosterChange}
						onInvalidDraft={onInvalidDraft}
						view={accommodationView}
						lms={lms}
					/>
				) : (
					<>
						<EditQuizSummary
							applications={applications}
							extensions={extensions}
							thirdPartyPlatforms={thirdPartyPlatforms}
							quizName={quizName}
							pendingLiveSessions={pendingLiveSessions}
							loading={loading}
							handleGoToStep={handleGoToStep}
							verityInstituteSettings={verityInstituteSettings}
							optionRelatedInstituteSettings={optionRelatedInstituteSettings}
							activeProfile={activeProfile}
							enforcedProfilesOnly={enforcedProfilesOnly}
							proctoringOption={proctoringOption}
							proctoringAssessmentConfiguration={proctoringAssessmentConfiguration}
							onManageAccommodations={hideAccommodations ? undefined : () => onViewChange("table")}
							allowedCategories={allowedCategories}
							numAccommodated={numAccommodated}
							referenceMaterialFiles={referenceMaterialFiles}
						/>
					</>
				)}
			</div>
		</StepWrapper>
	);
}
